<template>
  <div class="personal-loan-interest-rate">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('string.editPawnInterestRate') }}
        </h3>
      </div>
      <div class="box-body">
        <pawn-interest-rate-form />
      </div>
    </div>
  </div>
</template>

<script>
import PawnInterestRateForm from './Form'
export default {
  name: 'Edit',
  components: { PawnInterestRateForm },
  metaInfo () {
    return {
      title: this.$t('string.editPawnInterestRate'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
